module.exports = __webpack_public_path__ + "static/media/fixed_voice_situation.5aade3d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_situation.svg
// module id = 3148
// module chunks = 0